module.exports = __webpack_public_path__ + "./static/img/company_default.8b5ae1f5d66a32dcdb4484a53a37da29.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company_default.png
// module id = ./client/src/assets/img/company_default.png
// module chunks = 0